import { BodySmallText } from '@prisjakt/ui/text/variants';
import styled from 'styled-components';

export const PriceLabel = styled(BodySmallText).attrs({
  containerProps: { 'data-test': 'PriceLabel' },
})`
  font-size: inherit;
`;
